'use strict'

# UserAgent
_ua = do ->
  IE = document.uniqueID
  ltIE6 = typeof window.addEventListener is undefined and typeof document.documentElement.style.maxHeight is undefined
  ltIE7 = typeof window.addEventListener is undefined and typeof document.querySelectorAll is undefined
  ltIE8 = typeof window.addEventListener is undefined and typeof document.getElementsByClassName is undefined
  ltIE9 = IE and typeof window.Worker is undefined
  IE6 = IE and ltIE6
  IE7 = IE and ltIE7 and not ltIE6
  IE8 = IE and ltIE8 and not ltIE7 and not ltIE6
  IE9 = IE and ltIE9 and not ltIE8 and not ltIE7 and not ltIE6
  IE10 = IE and not ltIE9 and not ltIE8 and not ltIE7 and not ltIE6
  Webkit = not document.uniqueID and not window.opera and not window.sidebar and not window.orientation and window.localStorage
  Safari = Webkit and navigator.vendor.search(/apple/i) isnt -1
  Chrome = Webkit and navigator.vendor.search(/google/i) isnt -1

  return {
    IE:IE,
    ltIE6:ltIE6,
    ltIE7:ltIE7,
    ltIE8:ltIE8,
    ltIE9:ltIE9,
    IE6:IE6,
    IE7:IE7,
    IE8:IE8,
    IE9:IE9,
    IE10:IE10,
    Firefox:window.sidebar,
    Opera:window.opera,
    Webkit:Webkit,
    Safari:Safari,
    Chrome:Chrome,
    Mobile:window.orientation
  }

# URL
url = do ->
  href = location.href.split('/')

  localRegex = /^\d+\.\d+\.\d+\.\d+/
  workRegex = /^.*\/pc\/[^\/]+\/.*$/

  for val , i in href
    if val is '' or i is href.length - 1 and val.indexOf('.')
      href.splice(i,1)

  if localRegex.test(location.hostname) is true or location.hostname.indexOf('localhost') isnt -1
    length = 2

  else if workRegex.test(location.href) is true
    length = 3

    for val , i in href
      if val is 'pc' and href[i-1] is 'work'
        length = 4

  else
    length = 1

  path = ''

  for j in [0..(length)]
    path += href[j]

    if j is 0
      path += '//'

    else
      path += '/'

  return path

# スムーススクロール関数モーション定義
jQuery.extend(
  jQuery.easing,{
    easeInOutCirc:
      (x, t, b, c, d) ->
        if (t/=d/2) < 1
          return -c/2 * (Math.sqrt(1 - t*t) - 1) + b
        c/2 * (Math.sqrt(1 - (t-=2)*t) + 1) + b
  }
)

window.onpageshow = (evt) ->
  if evt.persisted
    location.reload()
  return

event = {
  all: 'mousedown touchstart pointerdown mouseenter mouseleave'
  type: ''
  start: ''
  enter: ''
  leave: ''
  move: ''
  end: ''
}
# イベント判定

event.check = (e) ->
  _default = e.type
  event.start = _default
  event.move = if _default is 'pointerdown' then 'pointermove' else if _default is 'touchstart' then 'touchmove' else 'mousemove'
  event.end = if _default is 'pointerdown' then 'pointerup' else if _default is 'touchstart' then 'touchend' else 'click'
  event.enter = if _default is 'pointerenter' then _default else if _default is 'touchenter' then _default else 'mouseenter'
  event.leave = if _default is 'pointerleave' then _default else if _default is 'touchleave' then _default else 'mouseleave'
  return

event.on = (type, elm, fn, delegate) ->
  $(document).off(event.all, elm).on(event.all, elm, (e) ->
    e.preventDefault()
    event.check(e)
    if fn isnt null
      if e.type is event.enter or e.type is event.leave
        # mouseenter mouseleaveのとき、コールバック関数を即実行
        fn(this, e)
      else
        if type is 'bind'
          # jQuery $(element).on(event, func);
          $(elm).off(event.end).on(event.end, (e) ->
            fn(this, e)
            return
          )
        else if type is 'live'
          # jQuery $(document).on(event, element, func);
          $(document).off(event.end, elm).on(event.end, elm, (e) ->
            fn(this, e)
            return
          )
        else if type is 'delegate'
          # jQuery $(parentsElement).on(event, element, func);
          $(delegate).off(event.end, elm).on(event.end, elm, (e) ->
            fn(this, e)
            return
          )
    else
      # 引数にコールバック関数が定義されていないときの処理
    return
  )
  return


$(()->
  $id = $('body').attr('id')
  $class = $('body').attr('class')

  # topBtn = $('.pagetop')
  # #最初はボタンを隠す
  # topBtn.hide()
  # #スクロールが300に達したらボタンを表示させる
  # $(window).scroll(->
  #   if $(this).scrollTop() > 300
  #     topBtn.fadeIn()
  #   else
  #     topBtn.fadeOut()
  #   return
  # )
  #
  # topBtn.click(->
  #   $('body,html').animate({
  #     scrollTop: 0
  #   }, 500
  #   )
  #   return false
  # )

  # $('.h-lead2').find('a').on('click',
  #   (e)->
  #     if $('body').is('[style]') and $('body').attr('style') is not ''
  #       currentPosition = Math.abs(parseInt($('body').css('top').replace('px')) * -1)
  #     else
  #       currentPosition = document.documentElement.scrollTop || document.body.scrollTop
  
  #     $('.input-form-privacy').css(
  #       'height': 'calc('+(document.documentElement.clientHeight - $('.l-header').outerHeight(true) + $(window).scrollTop())+'px - 2rem)'
  #     )
  
  #     $('body').css(
  #       'top': currentPosition * -1
  #     ).addClass('is-fixed')
  
  #     $('.m-input-form').addClass('show-privacy')
  
  #     e.stopPropagation()
  # )
  
  # $('.input-form').find('.button-close').on('click',
  #   ()->
  #     currentPosition = Math.abs(parseInt($('body').css('top').replace('px')) * -1)
  
  #     $('body').removeClass('is-fixed')
  #     $('body').removeAttr('style')
  
  #     $(
  #       if (navigator.userAgent.indexOf('Opera') isnt -1)
  #       then (
  #         if document.compatMode is 'BackCompat'
  #         then 'body'
  #         else 'html'
  #       )
  #       else 'html,body'
  #     ).animate(
  #       scrollTop : currentPosition
  #     , 0);
  
  #     $('.m-input-form').removeClass('show-privacy')
  # )
  
  # $('body.is-fixed').on('click',
  #   (e)->
  #     e.stopPropagation()
  #     currentPosition = Math.abs(parseInt($('body').css('top').replace('px')) * -1)
  
  #     $('body').removeClass('is-fixed')
  #     $('body').removeAttr('style')
  
  #     $(
  #       if (navigator.userAgent.indexOf('Opera') isnt -1)
  #       then (
  #         if document.compatMode is 'BackCompat'
  #         then 'body'
  #         else 'html'
  #       )
  #       else 'html,body'
  #     ).animate(
  #       scrollTop : currentPosition
  #     , 0);
  
  #     $('.m-input-form').removeClass('show-privacy')
  # )
  
  # $('.input-form-wrapper, .input-form-privacy').on('click',
  #   (e)->
  #     e.stopPropagation()
  # )
  
  # フォーム同一ウィンドウ表示
  # if parent.$('body').attr('id') is 'index'
  #   $('body').addClass('is-popup')
  # else
  #   $('body').addClass('is-active')
  
  # form = $('form[id$=_form]')
  #
  # if typeof form isnt 'undefined'
  #   form.off()
  #   form.unbind()
  #   $('div[id*=err_]').remove()
  #   $('#error').remove()
  #   if typeof common_validation isnt 'undefined'
  #
  #     # フォーム同一ウィンドウ表示
  #     # if $class.indexOf('confirmation') isnt -1
  #     # else
  #     #   formValues = form.serializeArray()
  #     #   $parentForm = parent.$('.m-form-input')
  #     #
  #     #   conf.customClearError = ()->
  #     #     $parentForm.empty()
  #     #     formValues = form.serializeArray()
  #     #
  #     #     $.each(formValues,
  #     #       (key, val)->
  #     #         val['type'] = 'hidden'
  #     #         $parentForm.append($('<input />', val))
  #     #     )
  #     #
  #     #     $parentForm.attr('action', form.attr('action'))
  #     #     $parentForm.submit()
  #     #
  #     # form.on('submit'
  #     #   (e)->
  #     #     if $class.indexOf('confirmation') isnt -1
  #     #     else
  #     #       if document.referrer.indexOf('confirmation') isnt -1
  #     #       else
  #     #         e.preventDefault()
  #     # )
  #
  #     # フォーム初期化
  #     common_validation.initializeForm(form, $id, 'message', '.net .text', 'after')
  #
  #     # フォームのページ遷移
  #     common_validation.controlPage($id)
  
  # フォーム同一ウィンドウ表示
  # $('.m-input-form').on('click'
  #   (e)->
  #     e.stopPropagation()
  # )
  #
  # $('body').on('click'
  #   (e)->
  #     e.stopPropagation()
  #     parent.$('.m-form-inner').removeAttr('src')
  #     parent.$('#m-form').removeClass('is-active')
  #     parent.$('body').removeClass('is-fixed')
  # )
  
  $('.input-form-text, .h-lead2').find('a').on('click', (e)->
    if $('.input-form-privacy').css('display') is 'none'
      $(this).addClass('is-open')
      $('.input-form-privacy').slideDown('normal')
    else
      $(this).removeClass('is-open')
      $('.input-form-privacy').slideUp('normal')
  )
)
